import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { ShiftPattern } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShiftPatternService extends TmsWebBaseEditService<ShiftPattern, ShiftPattern> {
  constructor() {
    super('ShiftPattern', $localize`Shift Pattern`);
  }
}
